export enum StoreNames {
  AppStoreCz = 'AppStoreCz',
  AppStoreDe = 'AppStoreDe',
  AppStoreEn = 'AppStoreEn',
  AppStoreFr = 'AppStoreFr',
  AppStoreHu = 'AppStoreHu',
  AppStoreNl = 'AppStoreNl',
  AppStorePl = 'AppStorePl',
  AppStoreRo = 'AppStoreRo',
  AppStoreSk = 'AppStoreSk',
  PlayStoreCz = 'PlayStoreCz',
  PlayStoreDe = 'PlayStoreDe',
  PlayStoreEn = 'PlayStoreEn',
  PlayStoreFr = 'PlayStoreFr',
  PlayStoreHu = 'PlayStoreHu',
  PlayStoreNl = 'PlayStoreNl',
  PlayStorePl = 'PlayStorePl',
  PlayStoreRo = 'PlayStoreRo',
  PlayStoreSk = 'PlayStoreSk',
}

export const storeBadgeIconAssets: {
  [key in StoreNames]: string;
} = {
  [StoreNames.AppStoreCz]: require('./apple-app-store-badge_cz.svg'),
  [StoreNames.AppStoreDe]: require('./apple-app-store-badge_de.svg'),
  [StoreNames.AppStoreEn]: require('./apple-app-store-badge_en.svg'),
  [StoreNames.AppStoreFr]: require('./apple-app-store-badge_fr.svg'),
  [StoreNames.AppStoreHu]: require('./apple-app-store-badge_hu.svg'),
  [StoreNames.AppStoreNl]: require('./apple-app-store-badge_nl.svg'),
  [StoreNames.AppStorePl]: require('./apple-app-store-badge_pl.svg'),
  [StoreNames.AppStoreRo]: require('./apple-app-store-badge_ro.svg'),
  [StoreNames.AppStoreSk]: require('./apple-app-store-badge_sk.svg'),
  [StoreNames.PlayStoreCz]: require('./google-play-badge_cz.svg'),
  [StoreNames.PlayStoreDe]: require('./google-play-badge_de.svg'),
  [StoreNames.PlayStoreEn]: require('./google-play-badge_en.svg'),
  [StoreNames.PlayStoreFr]: require('./google-play-badge_fr.svg'),
  [StoreNames.PlayStoreHu]: require('./google-play-badge_hu.svg'),
  [StoreNames.PlayStoreNl]: require('./google-play-badge_nl.svg'),
  [StoreNames.PlayStorePl]: require('./google-play-badge_pl.svg'),
  [StoreNames.PlayStoreRo]: require('./google-play-badge_ro.svg'),
  [StoreNames.PlayStoreSk]: require('./google-play-badge_sk.svg'),
};
